import { render, staticRenderFns } from "./imgB.vue?vue&type=template&id=76f9315b&scoped=true"
var script = {}
import style0 from "./imgB.vue?vue&type=style&index=0&id=76f9315b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f9315b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f9315b')) {
      api.createRecord('76f9315b', component.options)
    } else {
      api.reload('76f9315b', component.options)
    }
    module.hot.accept("./imgB.vue?vue&type=template&id=76f9315b&scoped=true", function () {
      api.rerender('76f9315b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgB.vue"
export default component.exports